module.exports = "//static.hsappstatic.net/settings-ui-app/static-1.16253/images/corgi-bark-sound.mp3"